// src/client/services/tasks/getUserTasks.js
import { apiClient } from "@/shared/services/apiClient";

export const getUserTasks = ({ auth0UserId, accessToken }) => {
	return apiClient(`/api/v1/leasing/users/${auth0UserId}/tasks`, {
		accessToken,
		errorMessage: "Failed to fetch tasks",
	});
};
